import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'antd/dist/reset.css'
import App from './App.tsx'
import '../styles/atnd.scss'
import '../styles/index.scss'

const PRELOAD_RELOAD_KEY = 'novus-preload-reload'
const PRELOAD_RELOAD_TTL_MS = 10_000

window.addEventListener('vite:preloadError', event => {
  event.preventDefault()
  const payload = event.payload instanceof Error ? event.payload.message : String(event.payload ?? '')
  const reloadKey = `${window.location.pathname}:${payload}`
  const lastReload = JSON.parse(sessionStorage.getItem(PRELOAD_RELOAD_KEY) || 'null') as { key?: string; at?: number } | null
  if (lastReload?.key === reloadKey && Date.now() - (lastReload.at ?? 0) < PRELOAD_RELOAD_TTL_MS) return
  sessionStorage.setItem(PRELOAD_RELOAD_KEY, JSON.stringify({ key: reloadKey, at: Date.now() }))
  window.location.reload()
})

window.addEventListener('load', () => {
  sessionStorage.removeItem(PRELOAD_RELOAD_KEY)
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
